import { Box, Button, Dialog, Stack, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { ChangeEvent, FC, FormEvent } from 'react';

import { useRootStore } from '~/base/hooks/useRootStore';
import { SignInFormFields } from '~/modules/auth/forms/SignInForm';

export const AuthModal: FC = observer(() => {
  const { authStore } = useRootStore();

  // Handlers

  const handleChangeLogin = (e: ChangeEvent<HTMLInputElement>) => {
    authStore.signInForm.setValue(SignInFormFields.login, e.target.value);
  };

  const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
    authStore.signInForm.setValue(SignInFormFields.password, e.target.value);
  };

  const handleLogin = (e: FormEvent) => {
    e.preventDefault();

    authStore.signIn(authStore.signInForm);
  };

  // Render

  return (
    <Dialog open={authStore.isOpenAuthModal} PaperProps={{ sx: { maxWidth: 450 } }}>
      <Box p={4}>
        <Stack spacing={2} component="form" onSubmit={handleLogin}>
          <Typography variant="h6">Форма авторизации для отдельной разработки микрофронтенда</Typography>

          <TextField
            required
            name="login"
            placeholder="Логин"
            value={authStore.signInForm.login}
            onChange={handleChangeLogin}
          />

          <TextField
            required
            name="password"
            placeholder="Пароль"
            value={authStore.signInForm.password}
            onChange={handleChangePassword}
          />

          <Button type="submit" variant="contained">
            Войти
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
});
